<template>
  <el-row>
    <el-row>
      <el-col
        :span="1"
        class="el-tabs__item"
        style="height:30px"
      >
      </el-col>
      <el-col
        :span="14"
        class="suitability_home left_text_align"
        @click.native="backHome"
        style="cursor: pointer;"
      ><i class="el-icon-s-home"></i>返回主页菜单<div class="imgs_logo" /></el-col>
      <!--el-col
        :span="9"
        @click.native="logoutAccount"
        class="logout_eng right_text_align"
        style="cursor: pointer;"
      >
        <span class="logout right_text_align font_title_email">{{ account }}</span><span class="logout right_text_align">[退出]</span>
      </el-col-->
      <el-col
        :span="9"
        @click.native="logoutAccount"
        class="suitability_home right_text_align"
        style="cursor: pointer;"
      >
        <span class="font_title_email">{{ account }}</span><span>[退出]</span>
      </el-col>
    </el-row>
    <el-row class="padding_30px_bottom padding_10px_top">
      <el-col
        :span="1"
        class="el-tabs__item  el-tabs__item"
      > </el-col>
      <el-col
        :span="8"
        class="head_title left_text_align"
      >{{
                homeTitle
            }}</el-col>
    </el-row>
  </el-row>
</template>
<script>
import { logout } from "../../utils/common";
import { getNameAndValue } from "../../utils/localStorage";

export default {
    data() {
        return {
            account: ""
        };
    },
    props: ["homeTitle"],
    mounted() {
        let self = this;
        let userInfo = getNameAndValue("info");
        if (userInfo != undefined && userInfo != null && userInfo != "") {
            const user = JSON.parse(userInfo);
            self.account = user.email;
        } else {
            logout(self);
        }
    },
    methods: {
        logoutAccount() {
            let self = this;
            logout(self);
        },
        backHome() {
            let self = this;
            self.$router.push({
                path: "/home"
            });
        }
    }
};
</script>
<style lang="scss">
.head_title {
    height: 67px;
    color: rgba(48, 49, 51, 1) !important;
    font-size: 40px !important;
}
.suitability_home {
    height: 25px;
    color: rgba(96, 98, 102, 1);
    font-size: 18px;
}
.imgs_logo {
    height: 25px;
    width: 100px;
    margin-top: -3%;
    margin-left: 69%;
    // background: url("./app/src/public/images/logo_image.png") no-repeat;
    background: url("../../public/images/logo_image.png") no-repeat;
}
</style>
